export default "__VITE_ASSET__DSkInlHX__"